import { render, staticRenderFns } from "./PlanReadInfo.vue?vue&type=template&id=10c67c1c&scoped=true&"
import script from "./PlanReadInfo.vue?vue&type=script&lang=js&"
export * from "./PlanReadInfo.vue?vue&type=script&lang=js&"
import style0 from "./PlanReadInfo.vue?vue&type=style&index=0&id=10c67c1c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c67c1c",
  null
  
)

export default component.exports